/** Las pestañas bajo los indicadores. Se identifican por nombre y no por posición. */
export type OperatingRoomTab = 'evolution' | 'heatmap' | 'rooms' | 'grouped' | 'times' | 'cancellations' | 'list'

/** En el orden en que se ofrecen. */
export const OPERATING_ROOM_TABS: readonly OperatingRoomTab[] = ['evolution', 'heatmap', 'rooms', 'grouped', 'times', 'cancellations', 'list']

export const OPERATING_ROOM_TAB_LABEL_ID: Record<OperatingRoomTab, string> = {
  evolution: 'OperatingRoomIndicatorsTabEvolution',
  heatmap: 'OperatingRoomIndicatorsTabHeatmap',
  rooms: 'OperatingRoomIndicatorsTabRooms',
  grouped: 'OperatingRoomIndicatorsTabGrouped',
  times: 'OperatingRoomIndicatorsTabTimes',
  cancellations: 'OperatingRoomIndicatorsTabCancellations',
  list: 'OperatingRoomIndicatorsTabList',
}
